export const iconFontAwesomeEducationPersonChalkboard = (
	<i className="fa-solid fa-person-chalkboard"></i>
);
